import { Component, OnInit, ViewChild } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { Router } from '@angular/router'
import { SeatMapsService } from 'src/app/shared/services/seat-maps.service'
import Swal from 'sweetalert2'

@Component({
  selector: 'app-seat-map-list',
  templateUrl: './seat-map-list.component.html',
  styleUrls: ['./seat-map-list.component.scss']
})
export class SeatMapListComponent implements OnInit {
  displayedColumns: string[] = ['name', 'enclosure', 'actions']
  dataSource: any
  @ViewChild(MatPaginator)
  paginator!: MatPaginator
  constructor(private seatMapsService: SeatMapsService, private router: Router) {}

  ngOnInit(): void {
    this.getData()
  }

  async getData() {
    ;(await this.seatMapsService.getAll()).subscribe({
      next: async (response: any) => {
        this.dataSource = new MatTableDataSource(response.seatMaps)
        this.dataSource.paginator = this.paginator
      },
      complete: () => {},
      error: (error: any) => {
        console.log(error)
      }
    })
  }

  delete(id: string) {
    Swal.fire({
      title: '¿Quieres borrar el mapa?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Borrar',
      denyButtonText: 'Cancelar'
    }).then(async result => {
      if (result.isConfirmed) {
        ;(await this.seatMapsService.delete(id)).subscribe({
          next: async (response: any) => {
            Swal.fire('Mapa borrado correctamente', '', 'success')
            this.getData()
          },
          complete: () => {},
          error: (error: any) => {
            Swal.fire('Error, no se ha podido borrar el mapa', '', 'error')
          }
        })
      }
    })
  }

  gotoCreate() {
    this.router.navigate(['/home/seat-map-new'])
  }

  gotoEdit(seatMap: any) {
    this.router.navigate(['/home/seat-map-new'], {
      state: { mode: 'edit', seatMap: seatMap }
    })
  }

  gotoWatch(seatMap: any) {
    this.router.navigate(['/home/seat-map-general'], {
      state: { mode: 'watch', seatMap: seatMap }
    })
  }
}
